<template>

<app-view-list-field :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <app-view-common-insight_play-players :item="item" :inline="true" v-if="item.players.length" />
    <span v-if="!item.players.length">-</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky']

}

</script>

<style scoped>

</style>